import React, { useEffect, useState } from "react";
import App from "./App";

import axios from "./utils/axios";
import ENDPOINTS from "./lib/api/endpoints";
import { setMetadata } from "./utils/metadata";
import Loader from "./components/Loader";

const Metadata = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(ENDPOINTS.PLATFORM.parameters)
      .then(({ data }) => {
        setMetadata(data.parameters);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  if (loading) return <Loader />;

  return <App />;
};

export default Metadata;
